import Vue from 'vue';
import Vuex from 'vuex';
import param from '../../static/config/param';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        collapse: false,
        //浏览器大小
        browser: {
            width: 960,
            height: 568
        },
        //mian大小
        content: {
            width: 0,
            height: 0
        },
        isLoad: false,
        token: '',
        language: '',        
        browserLanguage: '',
        timeFormat: '',
        user: {},
        areaIds: [],
        areaTree: [],
        lbs: [],
        mapType: '',
        indicatorCmd: '',
        deviceTypeList: [],
        deviceModelList: [],
        //验证码倒计时(时间戳，秒)
        captchaSeconds: 0,
        //列表高度
        tableHeight: 285,
        //正在按住鼠标
        pressing: false,
        departmentTree: [],
        departmentIds: [],
        roles: [],
        //权限
        role: param.role,
        //根部门id
        departmentId:'',
        mqttData:{}
    },
    mutations: {
        SET_ROLE: (state, role) => {
            state.role = role;
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles;
        },
        SET_DEPARTMENTTREE: (state, departmentTree) => {
            state.departmentTree = departmentTree;
        },
        SET_PRESSING: (state, pressing) => {
            state.pressing = pressing;
        },
        SET_TABLEHEIGHT: (state, tableHeight) => {
            state.tableHeight = tableHeight;
        },
        SET_CAPTCHASECONDS: (state, captchaSeconds) => {
            state.captchaSeconds = captchaSeconds;
        },
        SET_BROWSER: (state, browser) => {
            state.browser = browser;
        },
        SET_MAPTYPE: (state, mapType) => {
            state.mapType = mapType;
        },
        SET_INDICATORCMD: (state, indicatorCmd) => {
            state.indicatorCmd = indicatorCmd;
        },
        SET_LBS: (state, lbs) => {
            state.lbs = lbs;
        },
        SET_COLLAPSE: (state, collapse) => {
            state.collapse = collapse;
        },
        SET_TIMEFORMAT: (state, timeFormat) => {
            state.timeFormat = timeFormat;
        },
        SET_ISLOAD: (state, isLoad) => {
            state.isLoad = isLoad;
        },
        SET_CONTENT: (state, content) => {
            state.content = content;
        },
        SET_LANGUAGE: (state, language) => {
            state.language = language;
        },
        SET_BROWSERLANGUAGE: (state, browserLanguage) => {
            state.browserLanguage = browserLanguage;
        },
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_USER: (state, user) => {
            state.user = user;
        },
        SET_AREAIDS: (state, areaIds) => {
            state.areaIds = areaIds;
        },
        SET_DEPARTMENTIDS: (state, departmentIds) => {
            state.departmentIds = departmentIds;
        },
        SET_AREATREE: (state, areaTree) => {
            state.areaTree = areaTree;
        },
        SET_DEVICETYPELIST: (state, deviceTypeList) => {
            state.deviceTypeList = deviceTypeList;
        },
        SET_DEVICEMODELLIST: (state, deviceModelList) => {
            state.deviceModelList = deviceModelList;
        },
        SET_DEPARTMENTID:(state, departmentId)=>{
            state.departmentId = departmentId;
        },
        SET_MQTTDATA: (state, mqttData) => {
            state.mqttData = mqttData;
        }
    }
});

export default store


// WEBPACK FOOTER //
// ./src/store/index.js